// export const myGetter = (state) => {
//   return state;
// };
export const getDarkModeStatus = (state) => {
  return state.darkMode;
};

export const getLanguage = (state) => {
  return state.language;
};
